/* ==========================================================================
   Metamorfosis Magazine — qr.js
   Minimal QR encoder (byte mode) that renders an inline, colourable SVG.
   Why client-side: Liquid cannot generate a QR matrix, and the client must be
   able to repoint the code from the theme editor without a rebuild.
   Supports versions 1-20, ECC levels L/M/Q/H. Enough for any store URL.
   ========================================================================== */
(function (global) {
  'use strict';

  /* ---------- GF(256) ---------- */
  var EXP = new Uint8Array(512), LOG = new Uint8Array(256);
  (function () {
    var x = 1;
    for (var i = 0; i < 255; i++) { EXP[i] = x; LOG[x] = i; x <<= 1; if (x & 0x100) x ^= 0x11d; }
    for (var j = 255; j < 512; j++) EXP[j] = EXP[j - 255];
  })();
  function gmul(a, b) { return (a === 0 || b === 0) ? 0 : EXP[LOG[a] + LOG[b]]; }

  function rsGenerator(deg) {
    var poly = [1];
    for (var i = 0; i < deg; i++) {
      var next = new Array(poly.length + 1).fill(0);
      for (var j = 0; j < poly.length; j++) {
        next[j] ^= gmul(poly[j], 1);
        next[j + 1] ^= gmul(poly[j], EXP[i]);
      }
      poly = next;
    }
    return poly;
  }

  function rsEncode(data, ecLen) {
    var gen = rsGenerator(ecLen);
    var res = new Array(ecLen).fill(0);
    for (var i = 0; i < data.length; i++) {
      var factor = data[i] ^ res[0];
      res.shift(); res.push(0);
      for (var j = 0; j < ecLen; j++) res[j] ^= gmul(gen[j + 1], factor);
    }
    return res;
  }

  /* ---------- Tables (versions 1-20) ---------- */
  /* total codewords per version */
  var TOTAL_CW = [0,26,44,70,100,134,172,196,242,292,346,404,466,532,581,655,733,815,901,991,1085];
  /* [ecCodewordsPerBlock, group1Blocks, group2Blocks] per version, per ECL */
  var ECB = {
    L: [null,[7,1,0],[10,1,0],[15,1,0],[20,1,0],[26,1,0],[18,2,0],[20,2,0],[24,2,0],[30,2,0],[18,2,2],
        [20,4,0],[24,2,2],[26,4,0],[30,3,1],[22,5,1],[24,5,1],[28,1,5],[30,5,1],[28,3,4],[28,3,5]],
    M: [null,[10,1,0],[16,1,0],[26,1,0],[18,2,0],[24,2,0],[16,4,0],[18,4,0],[22,2,2],[22,3,2],[26,4,1],
        [30,1,4],[22,6,2],[22,8,1],[24,4,5],[24,5,5],[28,7,3],[28,10,1],[26,9,4],[26,3,11],[26,3,13]],
    Q: [null,[13,1,0],[22,1,0],[18,2,0],[26,2,0],[18,2,2],[24,4,0],[18,2,4],[22,4,2],[20,4,4],[24,6,2],
        [28,4,4],[26,4,6],[24,8,4],[20,11,5],[30,5,7],[24,15,2],[28,1,15],[28,17,1],[26,17,4],[30,15,5]],
    H: [null,[17,1,0],[28,1,0],[22,2,0],[16,4,0],[22,2,2],[28,4,0],[26,4,1],[26,4,2],[24,4,4],[28,6,2],
        [24,3,8],[28,7,4],[22,12,4],[24,11,5],[24,11,7],[30,3,13],[28,2,17],[28,2,19],[26,9,16],[28,15,10]]
  };
  /* alignment pattern centre coordinates per version */
  var ALIGN = [[],[],[6,18],[6,22],[6,26],[6,30],[6,34],[6,22,38],[6,24,42],[6,26,46],[6,28,50],
    [6,30,54],[6,32,58],[6,34,62],[6,26,46,66],[6,26,48,70],[6,26,50,74],[6,30,54,78],[6,30,56,82],
    [6,30,58,86],[6,34,62,90]];

  function ecTotal(v, ecl) { var e = ECB[ecl][v]; return e[0] * (e[1] + e[2]); }
  function dataCapacityBits(v, ecl) { return (TOTAL_CW[v] - ecTotal(v, ecl)) * 8; }

  function utf8Bytes(str) {
    var out = [], s = encodeURIComponent(str);
    for (var i = 0; i < s.length; i++) {
      if (s[i] === '%') { out.push(parseInt(s.substr(i + 1, 2), 16)); i += 2; }
      else out.push(s.charCodeAt(i));
    }
    return out;
  }

  /* ---------- Bit buffer ---------- */
  function Bits() { this.bits = []; }
  Bits.prototype.put = function (val, len) {
    for (var i = len - 1; i >= 0; i--) this.bits.push((val >>> i) & 1);
  };

  /* ---------- Encode ---------- */
  function encode(text, ecl) {
    ecl = ecl || 'M';
    var bytes = utf8Bytes(text);
    var version = 0;
    for (var v = 1; v <= 20; v++) {
      var ccBits = v < 10 ? 8 : 16;
      if (4 + ccBits + bytes.length * 8 <= dataCapacityBits(v, ecl)) { version = v; break; }
    }
    if (!version) throw new Error('QR: content too long');

    var capBits = dataCapacityBits(version, ecl);
    var bb = new Bits();
    bb.put(4, 4);
    bb.put(bytes.length, version < 10 ? 8 : 16);
    for (var i = 0; i < bytes.length; i++) bb.put(bytes[i], 8);
    for (var t = 0; t < 4 && bb.bits.length < capBits; t++) bb.bits.push(0);
    while (bb.bits.length % 8 !== 0) bb.bits.push(0);
    var pad = [0xEC, 0x11], pi = 0;
    while (bb.bits.length < capBits) { bb.put(pad[pi++ % 2], 8); }

    /* bits -> data codewords */
    var data = [];
    for (var b = 0; b < bb.bits.length; b += 8) {
      var byte = 0;
      for (var k = 0; k < 8; k++) byte = (byte << 1) | bb.bits[b + k];
      data.push(byte);
    }

    /* split into blocks */
    var e = ECB[ecl][version];
    var ecLen = e[0], g1 = e[1], g2 = e[2];
    var totalBlocks = g1 + g2;
    var dcTotal = TOTAL_CW[version] - ecTotal(version, ecl);
    var g1Len = Math.floor(dcTotal / totalBlocks);
    var g2Len = g1Len + 1;

    var dBlocks = [], eBlocks = [], off = 0;
    for (var bi = 0; bi < totalBlocks; bi++) {
      var len = bi < g1 ? g1Len : g2Len;
      var blk = data.slice(off, off + len); off += len;
      dBlocks.push(blk);
      eBlocks.push(rsEncode(blk, ecLen));
    }

    /* interleave */
    var out = [];
    for (var c = 0; c < g2Len; c++) {
      for (var bj = 0; bj < totalBlocks; bj++) if (c < dBlocks[bj].length) out.push(dBlocks[bj][c]);
    }
    for (var c2 = 0; c2 < ecLen; c2++) {
      for (var bk = 0; bk < totalBlocks; bk++) out.push(eBlocks[bk][c2]);
    }

    return buildMatrix(version, ecl, out);
  }

  /* ---------- Matrix ---------- */
  function buildMatrix(version, ecl, codewords) {
    var size = version * 4 + 17;
    var m = [], fn = [];
    for (var i = 0; i < size; i++) { m.push(new Array(size).fill(0)); fn.push(new Array(size).fill(0)); }

    function setFn(x, y, v) { if (x >= 0 && y >= 0 && x < size && y < size) { m[y][x] = v; fn[y][x] = 1; } }

    /* finder + separators */
    [[0, 0], [size - 7, 0], [0, size - 7]].forEach(function (p) {
      for (var dy = -1; dy <= 7; dy++) for (var dx = -1; dx <= 7; dx++) {
        var x = p[0] + dx, y = p[1] + dy;
        var inRing = (dx >= 0 && dx <= 6 && dy >= 0 && dy <= 6) &&
          (dx === 0 || dx === 6 || dy === 0 || dy === 6 || (dx >= 2 && dx <= 4 && dy >= 2 && dy <= 4));
        setFn(x, y, inRing ? 1 : 0);
      }
    });

    /* timing */
    for (var t = 8; t < size - 8; t++) { setFn(t, 6, t % 2 === 0 ? 1 : 0); setFn(6, t, t % 2 === 0 ? 1 : 0); }

    /* alignment */
    var centres = ALIGN[version];
    for (var a = 0; a < centres.length; a++) for (var b = 0; b < centres.length; b++) {
      var cx = centres[a], cy = centres[b];
      if ((cx === 6 && cy === 6) || (cx === 6 && cy === size - 7) || (cx === size - 7 && cy === 6)) continue;
      for (var yy = -2; yy <= 2; yy++) for (var xx = -2; xx <= 2; xx++) {
        setFn(cx + xx, cy + yy, (Math.max(Math.abs(xx), Math.abs(yy)) !== 1) ? 1 : 0);
      }
    }

    /* dark module + format area reservation */
    setFn(8, size - 8, 1);
    for (var f = 0; f <= 8; f++) { if (f !== 6) { setFn(f, 8, 0); setFn(8, f, 0); } }
    for (var f2 = 0; f2 < 8; f2++) { setFn(size - 1 - f2, 8, 0); setFn(8, size - 1 - f2, 0); }

    /* version info (v >= 7) */
    if (version >= 7) {
      var rem = version;
      for (var vi = 0; vi < 12; vi++) rem = (rem << 1) ^ ((rem >>> 11) * 0x1f25);
      var vbits = (version << 12) | rem;
      for (var k = 0; k < 18; k++) {
        var bit = (vbits >>> k) & 1;
        setFn(Math.floor(k / 3), size - 11 + (k % 3), bit);
        setFn(size - 11 + (k % 3), Math.floor(k / 3), bit);
      }
    }

    /* data placement — zigzag from bottom right */
    var bitIdx = 0;
    function dataBit() {
      if (bitIdx >= codewords.length * 8) return 0;
      var byte = codewords[bitIdx >> 3];
      var bit = (byte >>> (7 - (bitIdx & 7))) & 1;
      bitIdx++;
      return bit;
    }
    var up = true;
    for (var col = size - 1; col >= 1; col -= 2) {
      if (col === 6) col--;
      for (var r = 0; r < size; r++) {
        var row = up ? size - 1 - r : r;
        for (var c = 0; c < 2; c++) {
          var x = col - c;
          if (fn[row][x]) continue;
          m[row][x] = dataBit();
        }
      }
      up = !up;
    }

    /* masking */
    var maskFns = [
      function (x, y) { return (x + y) % 2 === 0; },
      function (x, y) { return y % 2 === 0; },
      function (x, y) { return x % 3 === 0; },
      function (x, y) { return (x + y) % 3 === 0; },
      function (x, y) { return (Math.floor(y / 2) + Math.floor(x / 3)) % 2 === 0; },
      function (x, y) { return (x * y) % 2 + (x * y) % 3 === 0; },
      function (x, y) { return ((x * y) % 2 + (x * y) % 3) % 2 === 0; },
      function (x, y) { return ((x + y) % 2 + (x * y) % 3) % 2 === 0; }
    ];

    var best = null, bestScore = Infinity;
    for (var mk = 0; mk < 8; mk++) {
      var cand = m.map(function (row) { return row.slice(); });
      for (var y2 = 0; y2 < size; y2++) for (var x2 = 0; x2 < size; x2++) {
        if (!fn[y2][x2] && maskFns[mk](x2, y2)) cand[y2][x2] ^= 1;
      }
      applyFormat(cand, fn, size, ecl, mk);
      var sc = penalty(cand, size);
      if (sc < bestScore) { bestScore = sc; best = cand; }
    }
    return { size: size, modules: best, version: version };
  }

  var ECL_BITS = { L: 1, M: 0, Q: 3, H: 2 };

  function applyFormat(mm, fn, size, ecl, mask) {
    var dataBits = (ECL_BITS[ecl] << 3) | mask;
    var rem = dataBits;
    for (var i = 0; i < 10; i++) rem = (rem << 1) ^ ((rem >>> 9) * 0x537);
    var bits = ((dataBits << 10) | rem) ^ 0x5412;

    for (var k = 0; k <= 5; k++) mm[k][8] = (bits >>> k) & 1;
    mm[7][8] = (bits >>> 6) & 1;
    mm[8][8] = (bits >>> 7) & 1;
    mm[8][7] = (bits >>> 8) & 1;
    for (var k2 = 9; k2 < 15; k2++) mm[8][14 - k2] = (bits >>> k2) & 1;

    for (var k3 = 0; k3 < 8; k3++) mm[8][size - 1 - k3] = (bits >>> k3) & 1;
    for (var k4 = 8; k4 < 15; k4++) mm[size - 15 + k4][8] = (bits >>> k4) & 1;
    mm[size - 8][8] = 1;
  }

  function penalty(mm, size) {
    var score = 0, x, y, run, i;
    /* rule 1: runs of 5+ */
    for (y = 0; y < size; y++) {
      run = 1;
      for (x = 1; x < size; x++) {
        if (mm[y][x] === mm[y][x - 1]) { run++; if (run === 5) score += 3; else if (run > 5) score++; }
        else run = 1;
      }
    }
    for (x = 0; x < size; x++) {
      run = 1;
      for (y = 1; y < size; y++) {
        if (mm[y][x] === mm[y - 1][x]) { run++; if (run === 5) score += 3; else if (run > 5) score++; }
        else run = 1;
      }
    }
    /* rule 2: 2x2 blocks */
    for (y = 0; y < size - 1; y++) for (x = 0; x < size - 1; x++) {
      var v = mm[y][x];
      if (v === mm[y][x + 1] && v === mm[y + 1][x] && v === mm[y + 1][x + 1]) score += 3;
    }
    /* rule 3: finder-like patterns */
    var pat1 = [1,0,1,1,1,0,1,0,0,0,0], pat2 = [0,0,0,0,1,0,1,1,1,0,1];
    function match(get, len, start) {
      for (var p = 0; p + 11 <= len; p++) {
        var ok1 = true, ok2 = true;
        for (i = 0; i < 11; i++) {
          var vv = get(start, p + i);
          if (vv !== pat1[i]) ok1 = false;
          if (vv !== pat2[i]) ok2 = false;
        }
        if (ok1) score += 40;
        if (ok2) score += 40;
      }
    }
    for (y = 0; y < size; y++) match(function (r, c) { return mm[r][c]; }, size, y);
    for (x = 0; x < size; x++) match(function (c, r) { return mm[r][c]; }, size, x);
    /* rule 4: dark ratio */
    var dark = 0;
    for (y = 0; y < size; y++) for (x = 0; x < size; x++) dark += mm[y][x];
    var pct = dark * 100 / (size * size);
    score += Math.floor(Math.abs(pct - 50) / 5) * 10;
    return score;
  }

  /* ---------- SVG rendering ---------- */
  function toSvgPath(qr, quiet) {
    quiet = quiet == null ? 4 : quiet;
    var s = qr.size, d = '';
    for (var y = 0; y < s; y++) for (var x = 0; x < s; x++) {
      if (qr.modules[y][x]) d += 'M' + (x + quiet) + ' ' + (y + quiet) + 'h1v1h-1z';
    }
    return { d: d, dim: s + quiet * 2 };
  }

  function render(host) {
    var text = host.getAttribute('data-qr');
    if (!text) return;
    var dark = host.getAttribute('data-qr-dark') || '#464d5a';
    var light = host.getAttribute('data-qr-light') || 'transparent';
    var ecl = host.getAttribute('data-qr-ecl') || 'H';   /* H so the centred mark is tolerated */
    var qr, p;
    try { qr = encode(text, ecl); p = toSvgPath(qr, 4); }
    catch (err) { host.setAttribute('data-qr-error', String(err.message)); return; }

    var svg =
      '<svg class="qr__svg" viewBox="0 0 ' + p.dim + ' ' + p.dim + '" xmlns="http://www.w3.org/2000/svg" ' +
      'role="img" aria-label="' + (host.getAttribute('data-qr-label') || 'QR code') + '" shape-rendering="crispEdges">' +
      '<rect width="' + p.dim + '" height="' + p.dim + '" fill="' + light + '"/>' +
      '<path d="' + p.d + '" fill="' + dark + '"/></svg>';

    var slot = host.querySelector('[data-qr-slot]') || host;
    slot.insertAdjacentHTML('afterbegin', svg);
    host.__svg = svg;
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-qr]'), function (h) {
      if (h.__qrDone) return;
      h.__qrDone = true;
      render(h);
    });
    /* Print-ready SVG download buttons */
    Array.prototype.forEach.call(document.querySelectorAll('[data-qr-download]'), function (btn) {
      if (btn.__wired) return;
      btn.__wired = true;
      btn.addEventListener('click', function () {
        var host = document.querySelector(btn.getAttribute('data-qr-download'));
        if (!host || !host.__svg) return;
        var blob = new Blob([host.__svg], { type: 'image/svg+xml' });
        var a = document.createElement('a');
        a.href = URL.createObjectURL(blob);
        a.download = 'metamorfosis-qr.svg';
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(a.href); }, 1000);
      });
    });
  }

  global.MetaQR = { encode: encode, toSvgPath: toSvgPath, render: render };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})(typeof window !== 'undefined' ? window : this);
